import React, {Component} from 'react'
import PropTypes from "prop-types";
import {doctorApi} from "../../services/ApiService";
import {authenticationService} from "../../services/AuthenticationService";
import SvGraphics from "../../assets/SvGraphics";
import Error from "../single_components/Error";


class TreatmentDosage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
            titrationPlan:this.props.titrationPlan
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      /*  if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }*/
    }

    componentDidMount() {


    }



    changeView = async (value,index)=> {
        this.props.getTitrationPlan(value,index)
    }

    editTreatmentPlan = (func,value,index) => {
        this.props.editTreatmentPlan(func,value,index)
    }

    render() {
        let {entry} = this.state
        let {t,titrationPlans}=this.props
        let currentEntry= this.props.current

        let monthlyDosage=[]
        for(let i=10;i<=100;i+=10){
            monthlyDosage.push(
                <option value={i}>{i}</option>
            )
        }

        let currentUser=authenticationService.currentUserValue;
        let language=localStorage.getItem('language')
        let titrationTemplates=[]
        if (titrationPlans){
            if(language==="he") {

                titrationTemplates = titrationPlans.map(item =>
                    <option value={item.Titration_code}> {item.Titration_name_he}</option>
                )
            }else{
                titrationTemplates = titrationPlans.map(item =>
                    <option value={item.Titration_code}> {item.Titration_name}</option>
                )
            }
        }


        let dailyDose=
            currentEntry.TreatmentMonthlyDosage?
                currentEntry.TreatmentMonthlyDosage==="Other"?
                    (currentEntry.TreatmentMonthlyDosageOther/30.5).toFixed(2)
                    :(currentEntry.TreatmentMonthlyDosage/30.5).toFixed(2)
                :0


        let titrations = []
        let currentIndex=1
        let stepupEvery=currentEntry.TreatmentStepUpEvery?parseInt(currentEntry.TreatmentStepUpEvery)-1:2
        if(!currentEntry.titrationPlan && currentEntry.Titration_code){
            this.changeView(currentEntry.Titration_code,this.props.index)
        }
        let titrationPlan=currentEntry.titrationPlan?currentEntry.titrationPlan:[]
        if(titrationPlan){
            for (let i = 0; i < 15; i++) {
                if(i < titrationPlan.length){
                    titrations.push(
                        <div className={"treatment-plan-box"}>
                            <div>
                                <label className={"treatment-plan-steps-label"}> {t('patient_boarding.Step')} {i + 1}</label>
                                <label className={"treatment-plan-steps-days-label"}> {t('patient_boarding.day')} {currentIndex}-{currentIndex+stepupEvery}</label>
                            </div>
                            <div>
                                <div className={"treatment-plan-icon-label"}>
                                    <div className={"treatment-plan-icon-back"}>
                                        <SvGraphics className={"treatment-plan-icon"} svgname={'morning-icon'}/>
                                    </div>
                                    <div className={"treatment-plan-box-arguments"}> {titrationPlan[i].M}</div>
                                </div>

                                <div className={"treatment-plan-icon-label"}>
                                    <div className={"treatment-plan-icon-back"}>
                                        <SvGraphics className={"treatment-plan-icon"} svgname={'noon-icon'}/>
                                    </div>
                                    <div className={"treatment-plan-box-arguments"}> {titrationPlan[i].N}</div>
                                </div>

                                <div className={"treatment-plan-icon-label"}>
                                    <div className={"treatment-plan-icon-back"}>
                                        <SvGraphics className={"treatment-plan-icon"} svgname={'evening-icon'}/>
                                    </div>
                                    <div className={"treatment-plan-box-arguments"}> {titrationPlan[i].E}</div>
                                </div>
                            </div>
                        </div>
                    )
                    currentIndex=currentIndex+stepupEvery+1
                }
            }
        }


        return (
            <div style={{display:this.props.view===3?'block':'none'}}>
                <div className={"treatment-plan-boxes-title"}> {t('patient_boarding.Dosage')}</div>

                <div className={'Treatment-Dosage-Row'}>
                    <div>
                        <div className='flex-Display'>
                            <div className={"treatment-plan-dosage-label"} >{t('patient_boarding.Monthly_Dosage')}*</div>
                            <Error errorClass={'error-message-label-flex'} isShown={!currentEntry.TreatmentMonthlyDosage}
                                   errorMessage={t('defaults.Registration.mandatoryField')}/>
                        </div>
                        <select className={'selectBox-treatment-dosage'} id="TreatmentSchedule" name="TreatmentMonthlyDosage" value={currentEntry.TreatmentMonthlyDosage}
                                onChange={(event) => this.editTreatmentPlan("TreatmentMonthlyDosage", event.target.value,this.props.index)}>
                            <option/>
                            {monthlyDosage}
                            <option value="Other">{t('patient_boarding.other')}</option>
                        </select>
                    </div>
                    <div style={{display:currentEntry.TreatmentMonthlyDosage=== "Other" ? 'block':'none'}}>
                        <div className={"treatment-plan-dosage-label"}>{t('patient_boarding.Enter_Dosage')}</div>
                        <input
                            className={'inputBoxStyle-treatment-dosage'} type="number" name="TreatmentMonthlyDosageOther"
                            value={currentEntry.TreatmentMonthlyDosageOther}
                            maxLength={3} min={0} max={200}
                            onChange={(event) => this.editTreatmentPlan("TreatmentMonthlyDosageOther", event.target.value,this.props.index)}/>
                    </div>

                    <div className={'inputSlots'}>
                        <div className={"treatment-plan-dosage-label"}>{t('patient_boarding.DailyDose')}</div>
                        <input readOnly className={'inputBoxStyle-treatment-dosage'} type="text"  name="BMI" value={dailyDose}
                               maxLength={2}/>
                    </div>
                </div>
                <div className={'Treatment-Dosage-Row'}>

                    <div>
                        <div className={"treatment-plan-dosage-label"} >{t('patient_boarding.Treatment_schedule')}</div>
                        <select className={'selectBoxTreatmentPlan'} id="TreatmentSchedule" name="TreatmentSchedule" value={currentEntry.TreatmentSchedule}
                                onChange={event => this.editTreatmentPlan("TreatmentSchedule", event.target.value,this.props.index)}>
                            <option/>
                            <option value="As needed">{t('patient_boarding.as_needed')}</option>
                            <option value="Maintenance">{t('patient_boarding.maintenance')}</option>
                            <option value="Titration">{t('patient_boarding.titration')}</option>
                        </select>
                    </div>
                </div>
                {currentEntry.TreatmentSchedule==="Titration"
                && <div>
                    <div className={"line-between"}/>

                    <div className={"treatment-plan-titration-label"}> {t('patient_boarding.Titration')}</div>
                    <div className={'Treatment-Dosage-Row'}>

                        <select className={'selectBoxTreatmentPlan'} id="Titration_code" name="Titration_code"
                                value={currentEntry.Titration_code}
                                onChange={(event) => this.changeView(event.target.value,this.props.index)}>
                            <option/>
                            {/*
                        <option value="New">{t('patient_boarding.New')}</option>
*/}
                            {titrationTemplates}
                        </select>
                    </div>

                    {currentEntry.Titration_code==="New" && <div className={'Treatment-Dosage-Row'}>
                        <div>
                            <div className={"treatment-plan-dosage-label"}>{t('patient_boarding.Initial_dose')}</div>
                            <input className={'inputBoxStyle-treatment-dosage'} type="number" defaultValue={currentEntry.TreatmentInitialDose}
                                   maxLength={2} min={0} max={20}
                                   onChange={(event) => this.editTreatmentPlan("TreatmentInitialDose", event.target.value, this.props.index)}/>
                            <label className={"treatment-plan-dosage-label"}>{t('patient_boarding.drops_puffs')}</label>

                        </div>
                        <div>
                            <div className={"treatment-plan-dosage-label"}>{t('patient_boarding.Treatment_Maximum_dosage')}</div>
                            <input className={'inputBoxStyle-treatment-dosage'} type="number"
                                   defaultValue={currentEntry.Treatment_Maximum_dosage}
                                   onChange={(event) => this.editTreatmentPlan("Treatment_Maximum_dosage", event.target.value, this.props.index)}/>
                            <label className={"treatment-plan-dosage-label"}>{t('patient_boarding.drops_puffs')}</label>

                        </div>
                        <div>
                            <div className={"treatment-plan-dosage-label"}>{t('patient_boarding.step_up')}</div>
                            <input className={'inputBoxStyle-treatment-dosage'} type="number" defaultValue={currentEntry.TreatmentStepUpEvery}
                                   maxLength={2}
                                   onChange={(event) => this.editTreatmentPlan("TreatmentStepUpEvery", event.target.value, this.props.index)}/>
                            <label className={"treatment-plan-dosage-label"}>{t('patient_boarding.step_up_Days')}</label>

                        </div>
                    </div>}

                    {currentEntry.Titration_code!=="New" && <div className={'Treatment-Dosage-Row'}>
                        <div>
                            <div className={"treatment-plan-dosage-label"}>{t('patient_boarding.Initial_dose')}</div>
                            <input className={'inputBoxStyle-treatment-dosage'} type="number" defaultValue={currentEntry.TreatmentInitialDose}
                                   maxLength={2} min={0} max={20}
                                   onChange={(event) => this.editTreatmentPlan("TreatmentInitialDose", event.target.value, this.props.index)}/>
                            <label className={"treatment-plan-dosage-label2"}>{t('patient_boarding.drops_puffs')}</label>

                        </div>
                        <div>
                            <div className={"treatment-plan-dosage-label"}>{t('patient_boarding.Treatment_Maximum_dosage')}</div>
                            <input className={'inputBoxStyle-treatment-dosage'} type="number"
                                   defaultValue={currentEntry.Treatment_Maximum_dosage}
                                   onChange={(event) => this.editTreatmentPlan("Treatment_Maximum_dosage", event.target.value, this.props.index)}/>
                            <label className={"treatment-plan-dosage-label2"}>{t('patient_boarding.drops_puffs')}</label>

                        </div>
                        <div>
                            <div className={"treatment-plan-dosage-label"}>{t('patient_boarding.step_up')}</div>
                            <input className={'inputBoxStyle-treatment-dosage'} type="number" defaultValue={currentEntry.TreatmentStepUpEvery}
                                   maxLength={2}
                                   onChange={(event) => this.editTreatmentPlan("TreatmentStepUpEvery", event.target.value, this.props.index)}/>
                            <label className={"treatment-plan-dosage-label2"}>{t('patient_boarding.step_up_Days')}</label>

                        </div>

                    </div>
                    }

                </div>
                }

                {currentEntry.TreatmentSchedule==="Titration" && <div>
{/*
                    <div className={"treatment-plan-boxes-title"}>{t('patient_boarding.treatment_plan')}</div>
*/}
                    <div className={"treatment-plan-boxes"}>
                        {titrations}
                    </div>

                </div>}


                <div className={'Treatment-Dosage-Row'}>

                </div>
            </div>

        )
    }
    }

TreatmentDosage.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default TreatmentDosage;
